import React from "react";
import useAuth from "../../Hooks/useAuth";
import ActionTop from "../../components/common/ActionTop";
import DiscoverItem from "../../components/common/DiscoverItem";

const ExploreAll = () => {
  const {data} = useAuth()
  return (
    <>
      <section className="popular">
        <div className="container">
          <div className="popular-content">
            <h2 className="pageTitle">
              Explo<span>re</span>
            </h2>
            <ActionTop />
            <div className="discover-items">
              {data.map((ele,i) => <DiscoverItem key={i} data={ele} />)}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExploreAll;
